<div
  [ngClass]="{ 'fixed bottom-[11px] right-28 z-[1000]': fixed }"
  class="flex gap-2"
>
  <button
    [id]="idButton"
    class="group relative text-white flex items-center border-none rounded-lg overflow-hidden shadow-md cursor-pointer bg-primary-900 py-[0.7em] px-[1em] pl-[0.9em] transition-all duration-200"
    pRipple
    (click)="onClick()"
  >
    <div class="svg-wrapper-1 left-0 right-0 w-full absolute">
      <div
        class="transition-all duration-300 pl-2 group-hover:pl-0 group-hover:w-full w-[1.6em] flex justify-center items-center"
      >
        <i class="pi {{ icon }}" style="font-size: 0.7rem"></i>
      </div>
    </div>
    <span
      class="pl-2 block ml-[0.3em] group-hover:translate-x-[calc(100%_+_1em)] transition-all duration-300 ease-in-out"
    >
      {{ texto }}
    </span>
  </button>

  @if(secondButton) {
  <button
    class="group relative text-white flex items-center border-none rounded-lg overflow-hidden shadow-md cursor-pointer bg-secondary-600 py-[0.7em] px-[1em] pl-[0.9em] transition-all duration-200"
    pRipple
    (click)="onClickSecondary()"
  >
    <div class="svg-wrapper-1 left-0 right-0 w-full absolute">
      <div
        class="transition-all duration-300 pl-2 group-hover:pl-0 group-hover:w-full w-[1.6em] flex justify-center items-center"
      >
        <i class="pi {{ secondIcon }}" style="font-size: 0.7rem"></i>
      </div>
    </div>
    <span
      class="pl-2 block ml-[0.3em] group-hover:translate-x-[calc(100%_+_1em)] transition-all duration-300 ease-in-out"
    >
      {{ secondTexto }}
    </span>
  </button>
  }
</div>
